import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
@Component({
  selector: 'app-auth-layout',
  standalone: false,
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.css'
})
export class AuthLayoutComponent {
  //Função para ocultar o vlivras na área adm, pois o vlibras precisa ser global para ser exibido
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const vw = document.querySelector('[vw]') as HTMLElement;
        if (!vw) return;

        if (event.url.startsWith('/authentication')) {
          vw.style.display = 'none';
        } else {
          vw.style.display = 'block';
        }
      }
    });
  }
  ngOnInit() {
  }
}
